(ns practitest.frontend.components2.dashboard.charts.protocol)

(defmulti render!
  "Render a chart to an SVG element."
  (fn [chart _ctx _svg-element] (:chart/type chart)))

(defmulti svg-for-export
  "Prepare svg before export to png | print
   Should rentrun clone of svg-element"
  (fn [chart _svg-element] (:chart/type chart)))

(defmulti transform-data
  "Transform raw chart data before rendering."
  :chart/type)

(defmulti split-layout?
  "Whether the chart renders in the split layout: a fixed y-axis and legend
   around a horizontally scrollable plot."
  :chart/type)

(defmethod split-layout? :default [_chart] false)
